import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout/layout";
import Seo from "../components/seo";

import { MainScreenFirst, CrumbsNav } from "../components/Pages/About";

import { contactsData } from "../db/contactsData";
import { foodDirectorsStatic } from "../db/foodDirectorsStatic";
import BeautyDirectors from "../components/Pages/BeautyDirectors/BeautyDirectors";

const foodDirectorsPage = ({ data }) => {
  const { strapiFoodDirectorsPage, strapiBeautyDirectorsPage } = data;

  return (
    <Layout>
      <Seo
        title={strapiFoodDirectorsPage?.seo_title}
        description={strapiFoodDirectorsPage?.seo_description}
      />

      <MainScreenFirst
        title={strapiFoodDirectorsPage.main.title}
        socials={contactsData.socials}
        showreel={strapiFoodDirectorsPage.main.showreel}
        video={strapiFoodDirectorsPage.main.video_cover}
        poster={strapiFoodDirectorsPage.main.poster}
      />

      <BeautyDirectors
        foodDirectors={strapiFoodDirectorsPage || []}
        beautyDirectors={strapiBeautyDirectorsPage || []}
        tickers={foodDirectorsStatic.tickers}
      />

      <CrumbsNav dataCrumbs={foodDirectorsStatic.crumbsNav} />
    </Layout>
  );
};

export default foodDirectorsPage;

export const query = graphql`
  query {
    strapiFoodDirectorsPage {
      seo_title
      seo_description
      main {
        title
        showreel
        video_cover {
          url
        }
        poster {
          url
        }
      }
      Directors {
        link
        title
        video {
          url
        }
      }
    }
    strapiBeautyDirectorsPage {
      main {
        title
        showreel
        video_cover {
          url
        }
        poster {
          url
        }
      }
    }
  }
`;
